<switch [disabled]="true" name="disabledSwitch"  [(ngModel)]="value1">Disabled switch checkbox input</switch>
<switch [disabled]="true" name="disabledSwitch"  [(ngModel)]="value2">Disabled checked switch checkbox input</switch>